import React from 'react';
import { InfoOffersContext, ChallengesContext, RewardsHubContext, } from '../../../../contexts';
import { HasDataStateOffers, ErrorStateBoth, LoadingStateOffers, } from './OfferCardStates';
export var OfferRewards = function (_a) {
    var isMobile = _a.isMobile, _b = _a.autoFetch, autoFetch = _b === void 0 ? true : _b;
    var _c = React.useContext(InfoOffersContext), isLoadingOffers = _c.isLoading, hasOffersError = _c.hasError, getPerksInfoOffersData = _c.getPerksInfoOffersData;
    var _d = React.useContext(ChallengesContext), isChallengeLoading = _d.isChallengeLoading, getChallengesInfo = _d.getChallengesInfo, hasChallengeError = _d.hasChallengeError;
    var isPageLoaded = React.useContext(RewardsHubContext).isPageLoaded;
    var _e = React.useState(0), loadingCount = _e[0], setLoadingCount = _e[1];
    var isInitiallyLoaded = loadingCount > 2; // ignore the first two renders (the 2 API calls)
    var isReady = !isLoadingOffers && !isChallengeLoading;
    var hasBothErrors = isReady && hasOffersError && hasChallengeError;
    React.useEffect(function () {
        setLoadingCount(function (prev) { return prev + 1; });
    }, [isChallengeLoading, isLoadingOffers]);
    React.useEffect(function () {
        var apiControllerCI = new AbortController();
        if (isPageLoaded && isChallengeLoading)
            getChallengesInfo({ signal: apiControllerCI.signal });
        setLoadingCount(function (prev) { return prev + 1; });
        return function () {
            apiControllerCI.abort();
        };
    }, [isChallengeLoading]);
    React.useEffect(function () {
        var apiControllerIO = new AbortController();
        if (autoFetch && isPageLoaded && isLoadingOffers)
            getPerksInfoOffersData({ signal: apiControllerIO.signal });
        return function () {
            apiControllerIO.abort();
        };
    }, [isLoadingOffers, autoFetch]);
    return React.useMemo(function () {
        if (!isInitiallyLoaded && !isReady)
            return React.createElement(LoadingStateOffers, null);
        if (hasBothErrors)
            return React.createElement(ErrorStateBoth, null);
        return React.createElement(HasDataStateOffers, null);
    }, [isMobile, isLoadingOffers, isChallengeLoading]);
};
